import { render, staticRenderFns } from "./VariantList.vue?vue&type=template&id=f786c032&"
import script from "./VariantList.vue?vue&type=script&lang=js&"
export * from "./VariantList.vue?vue&type=script&lang=js&"
import style0 from "./VariantList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports